"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordFieldWithoutAdornment = exports.PasswordFieldWithoutAdornmentArgs = void 0;
var get_component_1 = require("../../shared/helpers/get-component");
var il_password_field_1 = require("./il-password-field");
// arguments
exports.PasswordFieldWithoutAdornmentArgs = {
    placeholder: 'Your password',
    hideAdornment: true,
};
exports.PasswordFieldWithoutAdornment = (0, get_component_1.getComponent)(il_password_field_1.ILPasswordField, exports.PasswordFieldWithoutAdornmentArgs);
